import styled from '@emotion/styled';

export const VideoWrapper = styled.div`
  ${({ theme }) => `
    position: relative;
    background-color: ${theme.colors.neutrals.grey6};
    border-radius: ${theme.borderRadius.small};
    overflow: hidden;
  `};
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin-top: -${theme.spacing(1)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(2)};
  `}
`;

export const VideoInner = styled.div<{ skipPadding: boolean; }>`
  ${({ theme, skipPadding }) => theme.media.showAt({ at: 1 })`
    position: relative;
    padding-bottom: ${skipPadding ? 0 : '56.25%'};
  `}
  ${({ theme, skipPadding }) => theme.media.showAt({ from: 2 })`
    padding-bottom: ${skipPadding ? 0 : '56.25%'};
  `}
  > video {
    max-height: 643.5px;
  }
  > iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`;

export const VideoAbsoluteFill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const VideoPlaceholder = styled(VideoAbsoluteFill)`
  overflow: hidden;
`;

export const VideoPlaceholderBg = styled(VideoAbsoluteFill)`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  filter: blur(15px);
`;
